import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
// import { Contracts_Rinkeby } from 'src/environments/environment';
import { AppService } from 'src/app/core/services/app.service';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { Web3Service } from 'src/app/core/services/web3.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-nft-products',
  templateUrl: './nft-products.component.html',
  styleUrls: ['./nft-products.component.scss']
})
export class NftProductsComponent implements OnInit {
  newApi = [];
  id = "1234";
  accountNumber: any;
  balance: string;
  marketPlace: any;
  tokenURIsList = [];
  tokenData: Object;
  tokenarray: any;
  network_name: string;
  userInfo: any;
  nftList: any;
  collectionDetails: any;
  cryptoSymbol: string;
  searchnft: string = "";
  cryptoToken: string;
  isCryptoWallet = environment.required_crypto_wallet;
  showMore: boolean = false;
  Contracts_Rinkeby: any;
  clientDetailsName:string = '';

  constructor(private contractservice: ContractService, private web3service: Web3Service, private router: Router,
    private route: ActivatedRoute, private ngxLoader: NgxUiLoaderService, private appService: AppService, private commanService: CommanSubscribeService, public toaster: ToastrService) { }

  ngOnInit() {
    this.Contracts_Rinkeby = this.web3service.Contracts_Rinkeby;
    this.network_name = "Ethereum Rinkeby"
    this.web3service.setNetwork(this.network_name)
    this.userInfo = this.commanService.userInfo;
    this.getNftList();
    this.cryptoSymbol = environment.clientDetails.crypto_symbol_black;
    this.clientDetailsName=environment.clientDetails.name
    this.cryptoToken = environment.clientDetails.crypto_token

    // this.web3service.connectedAccId.subscribe(walletId => this.accountNumber = walletId)
    // if (this.accountNumber === undefined || this.accountNumber == null || this.accountNumber == "") {
    //   alert("Please connect your wallet")
    //   this.web3service.connectAccount().then(() => {
    //     this.web3service.setContract();
    //     console.log("Account Connected: ", this.accountNumber)
    //     this.getlist();
    //   })
    //   return
    // } else {
    //   console.log("Account Connected: ", this.accountNumber);
    //   this.web3service.setContract();
    //   this.getlist();
    // }
  }
  // getlist() {
  //   let marketplacecontract = this.web3service.getContract('MarketPlace')
  //   let erc721contract = this.web3service.getContract('ERC721')
  //   let erc1155contract = this.web3service.getContract('ERC1155')

  //   this.web3service.checkAndInstantiateWeb3().then((isweb3: any) => {
  //     if (isweb3 === 'connected') {
  //       marketplacecontract.methods.getFixedSaleNFT().call()
  //         .then(response => {
  //           console.log("Response from getFixedSaleNFT", response)
  //           this.tokenarray = response
  //           let numTokens = response.length;
  //           console.log("Length of array: ", numTokens)
  //           for (let i = 0; i < numTokens; i++) {
  //             console.log("TokenId: ", (this.tokenarray[i])[1])
  //             let tokenId = (this.tokenarray[i])[1]
  //             erc721contract.methods.tokenURI(tokenId).call()
  //               .then(response => {
  //                 this.appService.getNFTJson(response).subscribe(
  //                   (json: any) => {
  //                     if (this.collectionId == json.collectionId) {
  //                       json['tokenURI_id'] = tokenId;
  //                       this.tokenURIsList.push(json)
  //                     }
  //                   })
  //               })
  //           }

  //         })
  //       this.web3service.checkAndInstantiateWeb3().then(isweb3 => {
  //         if (isweb3 === 'connected') {
  //           let marketplacecontract = this.web3service.getContract('MarketPlace')
  //           console.log("Methods in MarketPlace ", marketplacecontract.methods)
  //           marketplacecontract.methods.getNftAuctionSaleDetails(Contracts_Rinkeby.SINGLE_NFT721_ADDRESS, 17).call()
  //             .then(resp => {
  //               console.log("response of getauctiondetails", resp)
  //             })
  //         }
  //       })

  //     } else {
  //       alert("Connect to WEB3 through browser extensions")
  //     }
  //   })

  // }

  lastEvaluatedKey: any;
  dataEnded: any = false;
  start: number = 8;
  busyGettingData = false;
  onScrollDown() {
    // you're at the bottom of the page
    if(this.dataEnded) {
      return;
    }
    this.ngxLoader.start()
    if (this.nftList?.length && this.lastEvaluatedKey == undefined && !this.dataEnded) {
      this.dataEnded = true;
      this.ngxLoader.stop();
      // this.toaster.success("End of Data");
    }
    else if (!this.busyGettingData){
      this.ngxLoader.start()
      this.busyGettingData = true;
      this.getNftList();
      this.ngxLoader.stop();
    }
  }

  getdata(data) {
    if (data.number_of_copies_for_sale > 0)
      this.router.navigate(['nft/product/overview/' + data.id])
  }
  collectionId: any;
  getNftList(search?) {
    this.ngxLoader.start();
    this.collectionId = this.route.snapshot.params.id;
    let url = "nft";
    let collectionsViewUrl = "nftCollectionViews";
    let payload = {
      collection_id: this.collectionId,
      limit: this.start,
      searchKey: this.searchnft,
      LastEvaluatedKey : this.lastEvaluatedKey ? this.lastEvaluatedKey : undefined
      // sortOrder : true
    }
    let viewPayload = {
      id: this.collectionId,
    }
    let header = {
      "Content-Type": "application/json",
      "x-api-key": environment.AWS_Cognito.X_Api_Key,
      "Authorization": `Bearer ${this.userInfo.access_token}`
    }
    let myInit = {
      headers: header,
      response: true,
      body: payload
    }
    let myInit1 = {
      headers: header,
      response: true,
      body: viewPayload
    }
    API.post(environment.AWS_Cognito.apiName, url, myInit).then(response => {
      if (response.data.statusCode == 200) {

        let data = response.data.response;
        if (this.lastEvaluatedKey) {
          this.start = this.start + 8;
          data.map((item) => {
            this.nftList.push(item)
          })
          this.busyGettingData = false;
        }
        else {
          this.nftList = data;
        }
        // this.nftList = response.data.response;
        this.lastEvaluatedKey = response.data.paginationToken;
        this.collectionDetails = response.data.nftCollectionDetails.Item;
        if (search == undefined) {
          API.post(environment.AWS_Cognito.apiName, collectionsViewUrl, myInit1).then(response => {
          }).catch(error => {
            console.log(error)
          });
        }
        this.ngxLoader.stop()
      }
    }).catch(error => {
      console.log(error)
      this.ngxLoader.stop()
    });
  }
}
